module.exports = __webpack_public_path__ + "img/comment.c9dfcf6.png";